import { AdminSettingKind } from "./admin.setting.kind";
import { SettingsUsageKind } from "./settings.usage.kind";

export class AdminSetting {
  Key: string;
  Description: string;
  Value: any;
  IsDocument: boolean;
  Placeholder: string;
  DoNotSaveSetting: boolean;
  Kind: AdminSettingKind;
  Sort: number;
  SettingsUsage: SettingsUsageKind;
}
